import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { VesselMovement } from '@/types';
import { CustomColumns, CustomTable } from '@/ui/components';
import { AppRoutes } from '@/routes';
import { dateConverter } from '@/utils/helpers';

type VesselDataGridInnerProps = {
  dataSource: VesselMovement[];
};

export const VesselDataGridInner = ({
  dataSource,
}: VesselDataGridInnerProps) => {
  const columns: CustomColumns<VesselMovement> = useMemo(
    () => [
      {
        dataIndex: 'serialNumber',
        title: 'Passport History',
        render: (value) => (
          <Link
            to={{
              pathname: AppRoutes.passport,
              search: `search=${value}`,
            }}
          >
            View
          </Link>
        ),
      },
      { dataIndex: 'serialNumber', title: 'Serial Number' },
      { dataIndex: 'productDesc', title: 'Product Desc' },
      {
        dataIndex: 'despatchDate',
        title: 'Despatch Date',
        render: (value) => dateConverter(value),
      },
      {
        dataIndex: 'etaDate',
        title: 'ETA Date',
        render: (value) => dateConverter(value),
      },
    ],
    [],
  );
  return (
    <CustomTable dataSource={dataSource} columns={columns} rowKey="vesselId" />
  );
};
